export default __webpack_public_path__ + "static/media/slide9.e93bf221.jpg";